import {
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    FormHelperText,
    Typography,
    Alert,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Button, useDataProvider, useNotify } from "react-admin";

export const SnVerify = ({
    open,
    onClose
}) => {
    const [loadingBatchStats, setLoadingBatchStats] = useState(false); // 新增加载状态
    const [batchStatsError, setBatchStatsError] = useState(''); // 新增错误信息
    const [resultNumber, setResultNumber] = useState(0);
    const [failNumber, setFailNumber] = useState(0);
    const [batchCustomers, setbatchCustomers] = useState([]);
    const [batchValue, setBatchValue] = useState(''); // 添加批次号状态

    const dataProvider = useDataProvider();
    const notify = useNotify();

    // 重置所有状态
    const resetDialogState = () => {
        setResultNumber(0);
        setFailNumber(0);
        setLoadingBatchStats(false);
        setBatchStatsError('');
        setBatchValue(''); // 重置批次号
    };

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const batchData = await dataProvider.batchNoList();
                setbatchCustomers(batchData.map(item => ({ id: item, name: item })));
            } catch (error) {
                console.error("获取客户数据失败:", error);
            }
        };

        if (open) {
            resetDialogState();
            fetchCustomers();
        }
    }, [open]);

    const generateTrafficSN = async () => {
        // 检查是否选择了批次号
        if (!batchValue) {
            notify('请先选择批次号', { type: 'warning' });
            return;
        }

        setLoadingBatchStats(true);
        setBatchStatsError('');

        try {
            const response = await dataProvider.validateSn(batchValue); // 使用选中的批次号
            setResultNumber(response.data.successCount);
            setFailNumber(response.data.failCount);
        } catch (error) {
            setBatchStatsError('获取批次统计信息失败');
            notify('获取批次统计信息失败', { type: 'error' });
            console.error("获取批次统计信息失败:", error);
        } finally {
            setLoadingBatchStats(false);
        }
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>流量SN校验</DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="normal" >
                    <InputLabel id="strategy-label">选择流量SN批次号校验</InputLabel>
                    <Select
                        labelId="strategy-label"
                        value={batchValue}
                        label="批次号"
                        onChange={(e) => setBatchValue(e.target.value)}
                    >
                        <MenuItem value="">请选择批次号</MenuItem>
                        {batchCustomers.map(strategy => (
                            <MenuItem key={strategy.id} value={strategy.id}>
                                {strategy.name}
                            </MenuItem>
                        ))}
                    </Select>
                    <FormHelperText>校验该批流量SN是否已经录入云商系统</FormHelperText>
                </FormControl>

                <FormControl fullWidth margin="normal">
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            p: 2,
                            border: '1px solid #e0e0e0',
                            borderRadius: '4px',
                            backgroundColor: '#fafafa'
                        }}
                    >
                        {loadingBatchStats ? (
                            // 加载状态显示
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                width: '100%'
                            }}>
                                <CircularProgress size={32} />
                                <Typography variant="body2" sx={{ mt: 2 }}>
                                    正在加载批次信息...
                                </Typography>
                            </Box>
                        ) : batchStatsError ? (
                            // 错误状态显示
                            <Alert severity="error" sx={{ width: '100%' }}>
                                {batchStatsError}
                            </Alert>
                        ) : (
                            // 正常数据显示
                            <>
                                <Box sx={{ fontSize: 16, fontWeight: 'bold', mb: 1 }}>
                                    批次号: {batchValue || '未选择'}
                                </Box>
                                <Box sx={{ display: 'flex', gap: 3, mt: 1 }}>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Box sx={{ fontSize: 14, color: 'text.secondary' }}>成功设备数</Box>
                                        <Box sx={{ fontSize: 24, fontWeight: 'bold', color: 'success.main' }}>
                                            {resultNumber}台
                                        </Box>
                                    </Box>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Box sx={{ fontSize: 14, color: 'text.secondary' }}>失败设备数</Box>
                                        <Box sx={{ fontSize: 24, fontWeight: 'bold', color: 'error.main' }}>
                                            {failNumber}台
                                        </Box>
                                    </Box>
                                </Box>
                            </>
                        )}
                    </Box>

                    <FormHelperText>提示：若校验后显示“成功设备数0，失败设备数0”表示该批次已校验，无设备需要再次校验</FormHelperText>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <Box sx={{ display: 'flex', justifyContent: 'end', gap: '8px' }}>
                        <Button
                            label="校验"
                            color="primary"
                            variant="contained"
                            onClick={generateTrafficSN}
                            disabled={!batchValue} // 当未选择批次号时禁用按钮
                        />
                    </Box>
                </FormControl>
            </DialogContent>
        </Dialog>
    );
};